'use client';

import GlobalErrorComponent from '@/components/global-error';
import { Suspense } from 'react';

export default function GlobalError() {
  return (
    <Suspense fallback={null}>
      <GlobalErrorComponent />
    </Suspense>
  );
}
